import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
  private _lang: string;
  public get lang(): string {
    return this._lang || this.cookieService.get('lang');
  }
  public set lang(v: string) {
    this._lang = v;
    this.cookieService.set('lang', this._lang, undefined, undefined, undefined, false, 'Strict');

  }

  constructor(public router: Router, public translator: TranslateService, public cookieService: CookieService, private renderer: Renderer2) {
    if (!this.lang) {
      this.lang = 'fa';
    }
    document.dir = this.lang == 'fa' ? 'rtl' : 'ltr';
    this.translator.setDefaultLang(this.lang);
    if (this.lang == 'fa') {
      this.renderer.addClass(document.body, 'samim');
      this.renderer.removeClass(document.body, 'sans');
    } else {
      this.renderer.addClass(document.body, 'sans');
      this.renderer.removeClass(document.body, 'samim');
    }
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}
